import React from 'react';
import api from '../../../api/apiClient';
import EventCalendarView from '../../../common/components/calendar/EventCalendarView';
import { EVENT_TYPE_META } from '../../../common/utils/calendarHelpers';

const ORG_CALENDAR_LEGEND = [
  EVENT_TYPE_META.vilt,
  EVENT_TYPE_META.assessment
];

const OrgEventCalendarPage = () => (
  <EventCalendarView
    title="Event Calendar"
    description="Organization VILT sessions, live meetings, and assessment schedules."
    emptyMessage="Organization events and assessment schedules will appear here."
    legendItems={ORG_CALENDAR_LEGEND}
    vltPath="/organization/vlt"
    assessmentMode="org"
    loadEvents={async ({ start, end }) => {
      const response = await api.calendar.getOrgEvents({ start, end });
      return response.data?.data || [];
    }}
  />
);

export default OrgEventCalendarPage;
